import React from "react";
import InsideHeader from "../../../components/InsideHeader";
import { useSelector } from "react-redux";
import { Descriptions } from "antd";
import { cashConverter, dateForHumans, numberWithCommas } from "../../../utils";

function FixedAssetDetails() {
  const { folderObj } = useSelector((state) => state.folder);
  const items = [
    {
      key: "1",
      label: "Item Name",
      children: folderObj?.faName,
    },

    {
      key: "2",
      label: "Value",
      children: <div>{numberWithCommas(folderObj?.faBookValue)}</div>,
    },
    {
      key: "3",
      label: "Acquisition Cost",
      children: <div>{cashConverter(folderObj?.faAcquisitionCost)}</div>,
    },
    {
      key: "4",
      label: "Serial Number",
      children: folderObj?.faSerialNumber,
    },
    {
      key: "7",
      label: "Description",
      children: folderObj?.faDescription,
    },
    {
      key: "5",
      label: "Created Date",
      children: <div>{dateForHumans(folderObj?.faCreatedDate)}</div>,
    },
    {
      key: "6",
      label: "Status",
      children: folderObj?.faStatus,
    },
  ];
  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Fixed assets information"
        subtitle="Manage Fixed assets within your institution"
        back={true}
        title1="Fixed Assets"
        title2="Fixed aseets details"
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="mt-[1.25rem]">
            <Descriptions
              column={{ xs: 1, sm: 2 }}
              colon={false}
              title="Fixed Assets Information"
              items={items}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FixedAssetDetails;
